import classNames from 'classnames';
import { ReactNode } from 'react';

interface Props {
  /** Glyph rendered inside the round icon chip (e.g. an inline `<svg>`). */
  icon: ReactNode;
  /** Background + text colour for the icon chip (e.g. `bg-mf-blue text-white`). */
  iconClassName?: string;
  /** Bold brand label (white). */
  label: ReactNode;
  /** Optional muted tagline shown after a separating dot. */
  tagline?: ReactNode;
  /** Extra classes on the pill (e.g. to tweak the bottom margin). */
  className?: string;
}

// Branded pill shown above a hero title — e.g. "MindFeed Classic · …" on the
// product hero, or "About MindFeed" on the About hero.
export const HeroBadge = ({
  icon,
  iconClassName,
  label,
  tagline,
  className,
}: Props) => (
  <span className={classNames(styles.pill, className)}>
    <span className={classNames(styles.icon, iconClassName)}>{icon}</span>
    <b className={styles.brand}>{label}</b>
    {tagline != null && (
      <>
        <span className={styles.dot}>·</span>
        {tagline}
      </>
    )}
  </span>
);

const styles = {
  pill: classNames(
    'mb-[22px] inline-flex items-center gap-[9px] rounded-full py-[7px] pl-2 pr-4',
    'text-[13px] font-semibold',
    'border border-[#DADADA] bg-white text-mf-gray-600',
    'marketing-dark:border-white/[0.15] marketing-dark:bg-white/[0.06] marketing-dark:text-[#cdd9f5]',
  ),
  icon: 'flex h-[22px] w-[22px] flex-shrink-0 items-center justify-center rounded-full',
  brand: 'font-bold text-mf-off-black-600 marketing-dark:text-white',
  dot: 'text-mf-gray-400 marketing-dark:text-white/40',
};
